"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverclaimShareDisplayHelper = void 0;
const OverclaimShareDisplayHelper = (share) => share && +(share - 100) >= 0 ? +(share - 100).toFixed(2) : 0;
exports.OverclaimShareDisplayHelper = OverclaimShareDisplayHelper;
